// extracted by mini-css-extract-plugin
module.exports = {"carousel":"HeroQuiz_carousel__KX7uR"};